(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fitment-purchase-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const cache = new Map();

    const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
    const keyPart = (value) => cleanText(value).toLowerCase();
    const selectionKey = (...parts) => parts.map(keyPart).join('|');
    const normalizeSize = (value) => cleanText(value).replace(/[" ]/g, '').toLowerCase();
    const normalizeBoltPattern = (value) =>
      cleanText(value)
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/mm$/i, '')
        .replace(/×/g, 'x');

    const fetchJson = async (url) => {
      if (cache.has(url)) return cache.get(url);

      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const data = await response.json();
      cache.set(url, data);
      return data;
    };

    const offsetText = (value) => {
      const number = Number(value);
      if (!Number.isFinite(number)) return cleanText(value);
      if (number > 0) return `+${number}`;
      return String(number);
    };

    const diameterFromSize = (value) => {
      const match = cleanText(value).match(/^(\d{2})(?:\.\d+)?\s*x/i);
      return match ? match[1] : '';
    };

    const sizeWidth = (value) => {
      const match = cleanText(value).match(/x\s*(\d{1,2}(?:\.\d+)?)/i);
      return match ? Number(match[1]) : 0;
    };

    const sortSizes = (items) =>
      [...items].sort((a, b) => {
        const diameterDiff = Number(diameterFromSize(a)) - Number(diameterFromSize(b));
        if (diameterDiff !== 0) return diameterDiff;
        return sizeWidth(a) - sizeWidth(b);
      });

    const sortDiameters = (items) => [...items].sort((a, b) => Number(a) - Number(b));
    const sortOffsets = (items) => [...items].filter((offset) => Number.isFinite(Number(offset))).sort((a, b) => Number(a) - Number(b));

    const customBuildWidthByDiameter = {
      17: [8, 8.5, 9, 9.5, 10, 10.5, 11],
      18: [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12],
      19: [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12],
      20: [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12],
      21: [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12],
      22: [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12],
    };
    const customBuildDiameters = Object.keys(customBuildWidthByDiameter);
    const customBuildSizesForDiameter = (diameter) =>
      (customBuildWidthByDiameter[cleanText(diameter)] || []).map((width) => `${cleanText(diameter)}x${width}`);
    const isCustomBuildSize = (rimSize) => {
      const diameter = diameterFromSize(rimSize);
      const width = sizeWidth(rimSize);
      return Boolean(customBuildWidthByDiameter[diameter]?.some((value) => Number(value) === Number(width)));
    };
    const sizeBoltKey = (rimSize, boltPattern) => `${normalizeSize(rimSize)}|${normalizeBoltPattern(boltPattern)}`;
    const diameterBoltKey = (diameter, boltPattern) => `${cleanText(diameter)}|${normalizeBoltPattern(boltPattern)}`;

    const parseSizeOption = (value) => {
      const text = cleanText(value);
      const sizeMatch = text.match(/(\d{2}(?:\.\d+)?)\s*x\s*(\d{1,2}(?:\.\d+)?)/i);
      if (!sizeMatch) return null;

      const offsetMatch = text.match(/\bET\s*([+-]?\d{1,3})\b/i) || text.match(/\b([+-]\d{1,3})\b/);
      const rimSize = `${Number(sizeMatch[1])}x${Number(sizeMatch[2])}`;

      return {
        label: text,
        rimSize,
        diameter: diameterFromSize(rimSize),
        normalizedRimSize: normalizeSize(rimSize),
        offset: offsetMatch ? Number(offsetMatch[1]) : null,
      };
    };

    const readProductData = (root) => {
      const script = root.querySelector('[data-fitment-purchase-product]');
      try {
        return script ? JSON.parse(script.textContent) : { options: [], variants: [] };
      } catch (error) {
        return { options: [], variants: [] };
      }
    };

    const readJsonScript = (root, selector, fallback) => {
      const script = root.querySelector(selector);
      if (!script) return fallback;

      try {
        const parsed = JSON.parse(script.textContent || 'null');
        if (typeof parsed === 'string') {
          try {
            return JSON.parse(parsed);
          } catch (error) {
            return fallback;
          }
        }
        return parsed ?? fallback;
      } catch (error) {
        return fallback;
      }
    };

    const normalizeSavedVehicle = (item) => {
      if (!item || typeof item !== 'object') return null;

      const year = cleanText(item.year || item.vehicleYear || item.y);
      const manufacturer = cleanText(item.manufacturer || item.make || item.m);
      const model = cleanText(item.model || item.vehicleModel || item.mo);
      const trim = cleanText(item.trim || item.configuration || item.t);

      if (!year || !manufacturer || !model || !trim) return null;

      const label = cleanText(item.label || item.name) || [year, manufacturer, model, trim].join(' ');
      return {
        key: selectionKey(year, manufacturer, model, trim),
        year,
        manufacturer,
        model,
        trim,
        label,
      };
    };

    const normalizeSavedVehicles = (data) => {
      let source = data;
      if (typeof source === 'string') {
        try {
          source = JSON.parse(source);
        } catch (error) {
          source = [];
        }
      }

      const vehicles = Array.isArray(source) ? source : Array.isArray(source?.vehicles) ? source.vehicles : [];
      const seen = new Set();
      return vehicles
        .map(normalizeSavedVehicle)
        .filter((vehicle) => {
          if (!vehicle || seen.has(vehicle.key)) return false;
          seen.add(vehicle.key);
          return true;
        });
    };

    const variantOptionValue = (variant, index) => {
      if (index < 0) return '';
      return cleanText(variant?.options?.[index] || variant?.[`option${index + 1}`]);
    };

    const buildVariantMap = (productData) => {
      const sizeIndex = productData.options.findIndex((option) => /size|diameter/i.test(option.name));
      const boltIndex = productData.options.findIndex((option) => /bolt/i.test(option.name));
      const colorIndex = productData.options.findIndex((option) => /color|finish/i.test(option.name));
      const sizeOptions = new Map();
      const boltPatterns = new Set();
      const diameters = new Set();

      productData.variants.forEach((variant) => {
        const sizeValue = variantOptionValue(variant, sizeIndex);
        const parsedSize = parseSizeOption(sizeValue);

        if (parsedSize) {
          const key = parsedSize.normalizedRimSize;
          if (!sizeOptions.has(key)) {
            sizeOptions.set(key, {
              rimSize: parsedSize.rimSize,
              diameter: parsedSize.diameter,
              values: [],
              offsets: new Set(),
            });
          }

          sizeOptions.get(key).values.push({
            variant,
            value: sizeValue,
            offset: parsedSize.offset,
          });

          diameters.add(parsedSize.diameter);
          if (parsedSize.offset !== null) {
            sizeOptions.get(key).offsets.add(parsedSize.offset);
          }
        } else if (sizeIndex >= 0) {
          const diameterValue = cleanText(sizeValue);
          if (/^\d{2}$/.test(diameterValue)) {
            diameters.add(diameterValue);
          }
        }

        const boltValue = variantOptionValue(variant, boltIndex);
        if (boltValue) boltPatterns.add(boltValue);
      });

      return {
        sizeIndex,
        boltIndex,
        colorIndex,
        sizeOptions,
        boltPatterns,
        diameters,
        customBuild: sizeIndex < 0 || sizeOptions.size === 0,
      };
    };

    const setOptions = (select, items, placeholder, disabled = false, autoSelectSingle = true, preferredValue = '') => {
      const previousValue = select.value;
      const preferred = preferredValue ? String(preferredValue) : '';
      select.replaceChildren();
      select.append(new Option(placeholder, ''));
      items.forEach((item) => {
        const option = new Option(item.label, item.value);
        if (item.setup) option.dataset.setup = JSON.stringify(item.setup);
        select.append(option);
      });
      select.disabled = disabled || items.length === 0;

      if (preferred && items.some((item) => String(item.value) === preferred)) {
        select.value = preferred;
      } else if (!preferred && items.some((item) => String(item.value) === previousValue)) {
        select.value = previousValue;
      } else if (autoSelectSingle && items.length === 1) {
        select.value = String(items[0].value);
      } else {
        select.value = '';
      }

      return previousValue !== select.value;
    };

    const selectValue = (select, value) => {
      if (!select || !value) return false;

      const match = Array.from(select.options).find((option) => option.value.toLowerCase() === String(value).toLowerCase());
      if (!match) return false;
      if (select.value === match.value) return false;

      select.value = match.value;
      const event = new Event('change', { bubbles: true });
      event.ekwFitmentManaged = true;
      select.dispatchEvent(event);
      return true;
    };

    const setupStyle = (setup) => {
      const [frontSize, frontOffset, rearSize, rearOffset] = setup;
      return normalizeSize(frontSize) === normalizeSize(rearSize) && Number(frontOffset) === Number(rearOffset) ? 'square' : 'staggered';
    };

    const setupKey = (setup) => [setup[0], setup[1], setup[2], setup[3]].map(cleanText).join('|');

    const setupPopularity = (setup) => Number(setup?.[6] || setup?.[4] || 0);

    const dedupeSetups = (setups) => {
      const seen = new Set();
      return setups
        .filter((setup) => {
          const key = setupKey(setup);
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        })
        .sort((a, b) => setupPopularity(b) - setupPopularity(a));
    };

    const formatSetupLabel = (setup) => {
      const [frontSize, frontOffset, rearSize, rearOffset] = setup;
      const front = `${frontSize} ${offsetText(frontOffset)}`;
      const rear = `${rearSize} ${offsetText(rearOffset)}`;
      return front === rear ? `${front}` : `Front ${front} / Rear ${rear}`;
    };

    const styleFromTrimName = (trim) => {
      const match = cleanText(trim).match(/\s+(staggered|square)$/i);
      return match ? match[1].toLowerCase() : '';
    };

    const displayTrimName = (trim) => {
      const text = cleanText(trim);
      const match = text.match(/\s+(staggered|square)$/i);
      if (!match) return text;
      return text.slice(0, match.index).replace(/\s+\S+$/, '').trim() || text;
    };

    const escapeHtml = (value) =>
      cleanText(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const cleanProperties = (properties) =>
      Object.entries(properties).reduce((memo, [key, value]) => {
        const cleanValue = cleanText(value);
        if (cleanValue) memo[key] = cleanValue;
        return memo;
      }, {});

    const findNativeOption = (productInfo, matcher) => {
      return Array.from(productInfo.querySelectorAll('[data-product-option-name]')).find((element) =>
        matcher(cleanText(element.dataset.productOptionName))
      );
    };

    const initFitmentPurchase = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const productInfo = root.closest('product-info');
      if (!productInfo) return;

      const productData = readProductData(root);
      const variantMap = buildVariantMap(productData);
      if (!Array.isArray(productData.variants) || productData.variants.length === 0) return;
      const profileSavedVehicles = normalizeSavedVehicles(readJsonScript(root, '[data-fitment-customer-vehicles]', []));

      root.hidden = false;

      const state = {
        lookup: null,
        trimGroups: new Map(),
        profileSavedVehicles,
        savedVehicles: [],
        savedVehiclePickerReady: false,
        savedVehiclePickerInitialized: false,
        activeSavedVehicleKey: '',
        savePromptDismissedKey: '',
        applyingSavedVehicle: false,
        savedVehicleAutoApplied: false,
        lookupOptionMap: null,
        rememberedSetupKey: '',
        rememberedSetup: null,
        squareQty: 4,
        frontQty: 2,
        rearQty: 2,
      };

      const hideManagedOptions = () => {
        productInfo.querySelectorAll('[data-product-option-name]').forEach((element) => {
          if (/size|diameter|bolt/i.test(element.dataset.productOptionName || '')) {
            element.classList.add('ekw-fitment-purchase__native-hidden');
          }
        });
      };

      const getNativeSize = () => findNativeOption(productInfo, (name) => /size|diameter/i.test(name))?.querySelector('select');
      const getNativeBolt = () => findNativeOption(productInfo, (name) => /bolt/i.test(name))?.querySelector('select');
      hideManagedOptions();

      const form = document.getElementById(root.dataset.productFormId);
      const nativeProductForm = form?.closest('product-form');
      const nativeSubmitButton = nativeProductForm?.querySelector('[type="submit"]') || form?.querySelector('[type="submit"]');
      const nativeSubmitButtonText = nativeSubmitButton?.querySelector('span');
      const modeInputs = Array.from(root.querySelectorAll('[data-fitment-mode]'));
      const styleInputs = Array.from(root.querySelectorAll('[data-fitment-setup-style]'));
      const yearSelect = root.querySelector('[data-fitment-year]');
      const manufacturerSelect = root.querySelector('[data-fitment-manufacturer]');
      const modelSelect = root.querySelector('[data-fitment-model]');
      const trimSelect = root.querySelector('[data-fitment-trim]');
      const diameterSelect = root.querySelector('[data-fitment-diameter]');
      const squareSizeSelect = root.querySelector('[data-fitment-square-size]');
      const frontSizeSelect = root.querySelector('[data-fitment-front-size]');
      const rearSizeSelect = root.querySelector('[data-fitment-rear-size]');
      const setupSelect = root.querySelector('[data-fitment-setup]');
      const boltSelect = root.querySelector('[data-fitment-bolt-pattern]');
      const manualSquareOffsetInput = root.querySelector('[data-fitment-manual-square-offset]');
      const manualFrontOffsetInput = root.querySelector('[data-fitment-manual-front-offset]');
      const manualRearOffsetInput = root.querySelector('[data-fitment-manual-rear-offset]');
      const result = root.querySelector('[data-fitment-result]');
      const resultStep = root.querySelector('[data-fitment-ui-step="result"]');
      const status = root.querySelector('[data-fitment-purchase-status]');
      const savedVehiclesField = root.querySelector('[data-fitment-saved-vehicles]');
      const savedVehicleSelect = root.querySelector('[data-fitment-saved-vehicle]');
      const newVehicleButton = root.querySelector('[data-fitment-new-vehicle]');
      const saveVehiclePrompt = root.querySelector('[data-fitment-save-vehicle-prompt]');
      const saveVehicleButton = root.querySelector('[data-fitment-save-vehicle]');
      const dismissSaveVehicleButton = root.querySelector('[data-fitment-dismiss-save-vehicle]');
      const saveVehicleStatus = root.querySelector('[data-fitment-save-vehicle-status]');

      const vehicleFields = [
        root.querySelector('[data-fitment-year-field]'),
        root.querySelector('[data-fitment-manufacturer-field]'),
        root.querySelector('[data-fitment-model-field]'),
        root.querySelector('[data-fitment-trim-field]'),
      ];
      const setupStyleField = root.querySelector('[data-fitment-setup-style-field]');
      const diameterField = root.querySelector('[data-fitment-diameter-field]');
      const squareSizeField = root.querySelector('[data-fitment-square-size-field]');
      const frontSizeField = root.querySelector('[data-fitment-front-size-field]');
      const rearSizeField = root.querySelector('[data-fitment-rear-size-field]');
      const setupField = root.querySelector('[data-fitment-setup-field]');
      const boltField = root.querySelector('[data-fitment-bolt-field]');
      const manualSquareOffsetField = root.querySelector('[data-fitment-manual-square-offset-field]');
      const manualFrontOffsetField = root.querySelector('[data-fitment-manual-front-offset-field]');
      const manualRearOffsetField = root.querySelector('[data-fitment-manual-rear-offset-field]');

      const properties = {
        mode: root.querySelector('[data-fitment-property-mode]'),
        vehicle: root.querySelector('[data-fitment-property-vehicle]'),
        setup: root.querySelector('[data-fitment-property-setup]'),
        diameter: root.querySelector('[data-fitment-property-diameter]'),
        frontWheel: root.querySelector('[data-fitment-property-front-wheel]'),
        rearWheel: root.querySelector('[data-fitment-property-rear-wheel]'),
        offset: root.querySelector('[data-fitment-property-offset]'),
        bolt: root.querySelector('[data-fitment-property-bolt]'),
      };

      const setStatus = (message) => {
        status.textContent = message || '';
      };

      const normalizeQuantity = (value) => {
        const number = Number(value);
        if (!Number.isFinite(number)) return 0;
        return Math.max(0, Math.floor(number));
      };

      const variantIdValue = (value) => cleanText(value).split('/').pop();

      const selectedProductOptionValues = (overrides = {}) =>
        productData.options.map((option, index) => {
          const optionKey = cleanText(option.name).toLowerCase();
          const override = overrides[index] || overrides[optionKey];
          if (override) return cleanText(override);

          const optionElement = Array.from(productInfo.querySelectorAll('[data-product-option-name]')).find(
            (element) => cleanText(element.dataset.productOptionName).toLowerCase() === cleanText(option.name).toLowerCase()
          );
          const select = optionElement?.querySelector('select');
          if (select) return cleanText(select.value);
          const checked = optionElement?.querySelector('input:checked');
          return cleanText(checked?.value);
        });

      const currentProductVariant = (overrides = {}) => {
        const selectedValues = selectedProductOptionValues(overrides);
        const selectedByOptions = productData.variants.find((variant) =>
          selectedValues.every((value, index) => !value || variantOptionValue(variant, index) === value)
        );
        if (selectedByOptions) return selectedByOptions;

        if (Object.keys(overrides).length > 0) return null;

        const idInput = form?.querySelector('[name="id"]');
        const selectedId = variantIdValue(idInput?.value);
        const selectedById = productData.variants.find((variant) => variantIdValue(variant?.id) === selectedId);
        return selectedById || productData.variants[0] || null;
      };

      const productVariantForDiameter = (diameter) => {
        const cleanDiameter = cleanText(diameter);
        if (!cleanDiameter || variantMap.sizeIndex < 0) return currentProductVariant();

        return currentProductVariant({
          [variantMap.sizeIndex]: cleanDiameter,
        });
      };

      const getMode = () => root.querySelector('[data-fitment-mode]:checked')?.value || 'vehicle';
      const getStyle = () => root.querySelector('[data-fitment-setup-style]:checked')?.value || '';

      const getSelectedSetup = () => {
        const value = setupSelect.selectedOptions[0]?.dataset.setup;
        if (!value) return null;
        try {
          return JSON.parse(value);
        } catch (error) {
          return null;
        }
      };

      const manualOffsetValue = (input) => {
        const value = cleanText(input?.value);
        if (!value) return null;
        const number = Number(value);
        return Number.isFinite(number) ? number : null;
      };

      const getManualSetup = () => {
        if (getMode() !== 'manual') return null;
        const style = getStyle();
        if (style === 'square') {
          const size = squareSizeSelect.value;
          const offset = manualOffsetValue(manualSquareOffsetInput);
          return size && offset !== null ? [size, offset, size, offset] : null;
        }
        if (style === 'staggered') {
          const frontSize = frontSizeSelect.value;
          const rearSize = rearSizeSelect.value;
          const frontOffset = manualOffsetValue(manualFrontOffsetInput);
          const rearOffset = manualOffsetValue(manualRearOffsetInput);
          return frontSize && rearSize && frontOffset !== null && rearOffset !== null ? [frontSize, frontOffset, rearSize, rearOffset] : null;
        }
        return null;
      };

      const clearRememberedSetup = () => {
        state.rememberedSetupKey = '';
        state.rememberedSetup = null;
      };

      const rememberSelectedSetup = () => {
        const setup = getSelectedSetup();
        if (!setupSelect.value || !setup) return;

        state.rememberedSetupKey = setupSelect.value;
        state.rememberedSetup = setup;
      };

      const getSelectedTrimGroup = () => state.trimGroups.get(trimSelect.value) || null;

      const vehicleReady = () => Boolean(yearSelect.value && manufacturerSelect.value && modelSelect.value && trimSelect.value);

      const vehicleLabel = () => [yearSelect.value, manufacturerSelect.value, modelSelect.value, trimSelect.value].filter(Boolean).join(' ');

      const vehicleFromCurrentSelection = () => {
        if (!vehicleReady()) return null;
        return normalizeSavedVehicle({
          year: yearSelect.value,
          manufacturer: manufacturerSelect.value,
          model: modelSelect.value,
          trim: trimSelect.value,
        });
      };

      const vehicleSearchComplete = () =>
        getMode() === 'vehicle' &&
        !state.applyingSavedVehicle &&
        vehicleReady() &&
        !yearSelect.disabled &&
        !manufacturerSelect.disabled &&
        !modelSelect.disabled &&
        !trimSelect.disabled &&
        Boolean(getSelectedTrimGroup());

      const savedVehicleStorageKey = () => `ekwSavedVehicles:${root.dataset.customerId || 'guest'}`;

      const loadLocalSavedVehicles = () => {
        try {
          return normalizeSavedVehicles(JSON.parse(window.localStorage.getItem(savedVehicleStorageKey()) || '[]'));
        } catch (error) {
          return [];
        }
      };

      const writeLocalSavedVehicles = (vehicles) => {
        try {
          window.localStorage.setItem(savedVehicleStorageKey(), JSON.stringify(vehicles));
          return true;
        } catch (error) {
          return false;
        }
      };

      const storeLocalVehicle = (vehicle) => {
        if (!vehicle) return false;

        const localVehicles = loadLocalSavedVehicles();
        const nextVehicles = [vehicle, ...localVehicles.filter((savedVehicle) => savedVehicle.key !== vehicle.key)];
        const changed = localVehicles.length !== nextVehicles.length || localVehicles[0]?.key !== vehicle.key;

        writeLocalSavedVehicles(nextVehicles);
        return changed;
      };

      const mergeSavedVehicles = () => {
        const seen = new Set();
        state.savedVehicles = [...state.profileSavedVehicles, ...loadLocalSavedVehicles()].filter((vehicle) => {
          if (!vehicle || seen.has(vehicle.key)) return false;
          seen.add(vehicle.key);
          return true;
        });
      };

      const renderSavedVehicleOptions = () => {
        if (!savedVehiclesField || !savedVehicleSelect) return;

        const showSavedVehicles = getMode() === 'vehicle' && state.savedVehiclePickerReady && state.savedVehicles.length > 0;
        savedVehiclesField.hidden = !showSavedVehicles;
        savedVehicleSelect.replaceChildren();
        savedVehicleSelect.append(new Option(root.dataset.selectSavedVehicle, ''));

        state.savedVehicles.forEach((vehicle) => {
          const option = new Option(vehicle.label, vehicle.key);
          option.dataset.vehicle = JSON.stringify(vehicle);
          savedVehicleSelect.append(option);
        });

        savedVehicleSelect.disabled = state.savedVehicles.length === 0;
        savedVehicleSelect.value = state.savedVehicles.some((vehicle) => vehicle.key === state.activeSavedVehicleKey) ? state.activeSavedVehicleKey : '';
      };

      const savedVehicleExists = (vehicle) => Boolean(vehicle && state.savedVehicles.some((savedVehicle) => savedVehicle.key === vehicle.key));

      const refreshSavedVehicles = () => {
        mergeSavedVehicles();
        if (!state.savedVehiclePickerInitialized) {
          state.savedVehiclePickerReady = state.savedVehicles.length > 0;
          state.savedVehiclePickerInitialized = true;
        }
        renderSavedVehicleOptions();
      };

      const waitForOption = async (select, value) => {
        const expectedValue = cleanText(value);
        for (let index = 0; index < 50; index += 1) {
          const options = Array.from(select.options || []);
          if (!select.disabled && options.some((option) => cleanText(option.value).toLowerCase() === expectedValue.toLowerCase())) {
            return true;
          }
          await new Promise((resolve) => window.setTimeout(resolve, 100));
        }
        return false;
      };

      const applySavedVehicle = async (vehicle) => {
        if (!vehicle) return false;

        state.applyingSavedVehicle = true;
        state.activeSavedVehicleKey = vehicle.key;
        state.rememberedSetupKey = '';
        state.rememberedSetup = null;

        const vehicleMode = modeInputs.find((input) => input.value === 'vehicle');
        if (vehicleMode && !vehicleMode.checked) {
          vehicleMode.checked = true;
          vehicleMode.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (!(await waitForOption(yearSelect, vehicle.year))) {
          state.applyingSavedVehicle = false;
          return false;
        }
        selectValue(yearSelect, vehicle.year);

        if (!(await waitForOption(manufacturerSelect, vehicle.manufacturer))) {
          state.applyingSavedVehicle = false;
          return false;
        }
        selectValue(manufacturerSelect, vehicle.manufacturer);

        if (!(await waitForOption(modelSelect, vehicle.model))) {
          state.applyingSavedVehicle = false;
          return false;
        }
        selectValue(modelSelect, vehicle.model);

        if (!(await waitForOption(trimSelect, vehicle.trim))) {
          state.applyingSavedVehicle = false;
          return false;
        }
        selectValue(trimSelect, vehicle.trim);

        state.applyingSavedVehicle = false;
        renderSavedVehicleOptions();
        refreshOptions();
        return vehicleReady();
      };

      const maybeAutoApplySavedVehicle = async () => {
        if (state.savedVehicleAutoApplied || getMode() !== 'vehicle' || vehicleReady() || state.savedVehicles.length !== 1) return;

        state.savedVehicleAutoApplied = true;
        await applySavedVehicle(state.savedVehicles[0]);
      };

      const updateSaveVehiclePrompt = () => {
        if (!saveVehiclePrompt) return;

        const currentVehicle = vehicleSearchComplete() ? vehicleFromCurrentSelection() : null;
        const shouldShow =
          root.dataset.customerLoggedIn === 'true' &&
          Boolean(currentVehicle) &&
          !savedVehicleExists(currentVehicle) &&
          state.savePromptDismissedKey !== currentVehicle.key;

        saveVehiclePrompt.hidden = !shouldShow;
        if (!shouldShow && saveVehicleStatus) saveVehicleStatus.textContent = '';
      };

      const saveCurrentVehicle = async () => {
        if (!vehicleSearchComplete()) return;
        const vehicle = vehicleFromCurrentSelection();
        if (!vehicle) return;

        storeLocalVehicle(vehicle);

        state.activeSavedVehicleKey = vehicle.key;
        state.savedVehiclePickerReady = true;
        refreshSavedVehicles();
        renderSavedVehicleOptions();
        updateSaveVehiclePrompt();

        if (saveVehicleStatus) {
          saveVehicleStatus.textContent = root.dataset.saveVehicleLocalSuccess || root.dataset.saveVehicleSuccess;
        }
      };

      const directBoltPattern = (vehicle) => {
        const boltPattern = vehicle?.b || vehicle?.boltPattern || vehicle?.bp;
        if (Array.isArray(boltPattern)) return cleanText(boltPattern[0]);
        if (typeof boltPattern === 'object') return cleanText(boltPattern.pattern);
        return cleanText(boltPattern);
      };

      const vehicleBoltPattern = (vehicle) => {
        const direct = directBoltPattern(vehicle);
        if (direct) return direct;

        for (const combinationId of vehicle?.c || []) {
          const pattern = directBoltPattern(state.lookup?.combinations?.[combinationId]);
          if (pattern) return pattern;
        }

        return '';
      };

      const vehicleSetups = (vehicle) => {
        const setups = [];
        if (Array.isArray(vehicle?.f)) setups.push(...vehicle.f);
        (vehicle?.c || []).forEach((combinationId) => {
          setups.push(...(state.lookup?.combinations?.[combinationId]?.f || []));
        });
        return dedupeSetups(setups);
      };

      const buildLookupOptionMap = () => {
        if (!state.lookup) {
          return {
            sizeOptions: new Map(),
            boltPatterns: new Set(),
            diameters: new Set(),
            offsetsBySizeBolt: new Map(),
            offsetsByDiameterBolt: new Map(),
            offsetsByDiameter: new Map(),
            offsetsByBolt: new Map(),
          };
        }
        if (state.lookupOptionMap) return state.lookupOptionMap;

        const sizeOptions = new Map();
        const boltPatterns = new Set();
        const diameters = new Set();
        const offsetsBySizeBolt = new Map();
        const offsetsByDiameterBolt = new Map();
        const offsetsByDiameter = new Map();
        const offsetsByBolt = new Map();

        const addOffset = (map, key, offset) => {
          const number = Number(offset);
          if (!key || !Number.isFinite(number)) return;
          if (!map.has(key)) map.set(key, new Set());
          map.get(key).add(number);
        };

        const ensureSize = (rimSize) => {
          const cleanSize = cleanText(rimSize);
          if (!cleanSize || !isCustomBuildSize(cleanSize)) return null;

          const key = normalizeSize(cleanSize);
          const diameter = diameterFromSize(cleanSize);

          if (!sizeOptions.has(key)) {
            sizeOptions.set(key, {
              rimSize: cleanSize,
              diameter,
              values: [],
              offsets: new Set(),
            });
          }

          if (diameter) diameters.add(diameter);
          return sizeOptions.get(key);
        };

        const addSize = (rimSize, offset, boltPattern = '') => {
          const cleanSize = cleanText(rimSize);
          const option = ensureSize(cleanSize);
          if (!option) return;

          const diameter = diameterFromSize(cleanSize);
          const cleanOffset = Number(offset);

          option.values.push({
            variant: null,
            value: cleanSize,
            offset: Number.isFinite(cleanOffset) ? cleanOffset : null,
          });
          if (Number.isFinite(cleanOffset)) {
            option.offsets.add(cleanOffset);
            addOffset(offsetsBySizeBolt, sizeBoltKey(cleanSize, boltPattern), cleanOffset);
            addOffset(offsetsByDiameterBolt, diameterBoltKey(diameter, boltPattern), cleanOffset);
            addOffset(offsetsByDiameter, diameter, cleanOffset);
            addOffset(offsetsByBolt, normalizeBoltPattern(boltPattern), cleanOffset);
          }
        };

        const addLookupSetup = (setup, boltPattern) => {
          addSize(setup?.[0], setup?.[1], boltPattern);
          addSize(setup?.[2], setup?.[3], boltPattern);
        };

        if (state.lookup?.v === 3 && state.lookup?.combinations) {
          Object.values(state.lookup.combinations).forEach((combination) => {
            const boltPattern = vehicleBoltPattern(combination);
            if (boltPattern) boltPatterns.add(boltPattern);
            (combination?.f || []).forEach((setup) => addLookupSetup(setup, boltPattern));
          });
        } else {
          Object.values(state.lookup?.vehicles || {}).forEach((vehicle) => {
            const boltPattern = vehicleBoltPattern(vehicle);
            if (boltPattern) boltPatterns.add(boltPattern);

            (vehicle?.f || []).forEach((setup) => addLookupSetup(setup, boltPattern));
          });
        }

        customBuildDiameters.forEach((diameter) => {
          customBuildSizesForDiameter(diameter).forEach(ensureSize);
        });

        state.lookupOptionMap = {
          sizeOptions,
          boltPatterns,
          diameters,
          offsetsBySizeBolt,
          offsetsByDiameterBolt,
          offsetsByDiameter,
          offsetsByBolt,
        };
        return state.lookupOptionMap;
      };

      const availableBoltPatterns = () => (variantMap.customBuild ? buildLookupOptionMap().boltPatterns : variantMap.boltPatterns);

      const ensureSelectOption = (select, label, value = label) => {
        const cleanValue = cleanText(value);
        if (!select || !cleanValue) return '';

        const match = Array.from(select.options).find((option) => normalizeBoltPattern(option.value) === normalizeBoltPattern(cleanValue));
        if (match) return match.value;

        select.append(new Option(label || cleanValue, cleanValue));
        return cleanValue;
      };

      const populateBoltPatternOptions = (preferredValue = '') => {
        const patterns = availableBoltPatterns();
        return setOptions(
          boltSelect,
          [...patterns].sort().map((pattern) => ({ label: pattern, value: pattern })),
          root.dataset.selectBoltPattern,
          patterns.size === 0,
          patterns.size === 1,
          preferredValue || boltSelect.value
        );
      };

      const getSelectedVehicleBoltPattern = () => {
        if (!state.lookup || !vehicleReady()) return '';
        const group = getSelectedTrimGroup();
        if (!group) return '';

        for (const rawTrim of group.rawTrims) {
          const vehicle = state.lookup.vehicles?.[selectionKey(yearSelect.value, manufacturerSelect.value, modelSelect.value, rawTrim)];
          const pattern = vehicleBoltPattern(vehicle);
          if (pattern) return pattern;
        }

        return '';
      };

      const productBoltValue = (boltPattern) => {
        const normalizedBolt = normalizeBoltPattern(boltPattern);
        if (!normalizedBolt) return '';

        const match = Array.from(boltSelect.options).find((option) => option.value && normalizeBoltPattern(option.value) === normalizedBolt);
        if (match) return match.value;

        return variantMap.customBuild ? ensureSelectOption(boltSelect, cleanText(boltPattern), cleanText(boltPattern)) : '';
      };

      const syncVehicleBoltPattern = () => {
        if (getMode() === 'manual') return boltSelect.value;

        const boltPattern = productBoltValue(getSelectedVehicleBoltPattern());
        boltSelect.value = boltPattern;
        return boltPattern;
      };

      const getVehicleSetups = () => {
        if (!state.lookup || !vehicleReady()) return [];
        const group = getSelectedTrimGroup();
        if (!group) return [];

        const setups = [];
        group.rawTrims.forEach((rawTrim) => {
          const vehicle = state.lookup.vehicles?.[selectionKey(yearSelect.value, manufacturerSelect.value, modelSelect.value, rawTrim)];
          vehicleSetups(vehicle).forEach((setup) => setups.push(setup));
        });
        return dedupeSetups(setups);
      };

      const getAvailableStyles = () => {
        if (getMode() === 'manual') return ['square', 'staggered'];

        const group = getSelectedTrimGroup();
        if (!group) return [];

        return ['square', 'staggered'].filter((style) => group.styles.has(style));
      };

      const setStyleOptions = (styles, preferredStyle = '') => {
        styleInputs.forEach((input) => {
          const label = input.closest('label');
          const supported = styles.includes(input.value);
          input.disabled = !supported;
          label.hidden = !supported;
          if (!supported) input.checked = false;
        });

        const current = getStyle();
        const preferred = styles.includes(preferredStyle) ? preferredStyle : '';
        if (preferred && current !== preferred) {
          const preferredInput = styleInputs.find((input) => input.value === preferred);
          if (preferredInput) preferredInput.checked = true;
        } else if (!styles.includes(current)) {
          const first = styleInputs.find((input) => styles.includes(input.value));
          if (first) first.checked = true;
        }

        setupStyleField.hidden = styles.length === 0 || (getMode() === 'vehicle' && styles.length === 1);
      };

      const customBuildOffsetsForSize = (rimSize, boltPattern = boltSelect.value) => {
        const lookupMap = buildLookupOptionMap();
        const rimOption = lookupMap.sizeOptions.get(normalizeSize(rimSize));
        if (!rimOption) return [];

        const diameter = diameterFromSize(rimOption.rimSize);
        const normalizedBolt = normalizeBoltPattern(boltPattern);
        const offsetSources = [
          normalizedBolt ? lookupMap.offsetsBySizeBolt.get(sizeBoltKey(rimOption.rimSize, normalizedBolt)) : null,
          normalizedBolt ? lookupMap.offsetsByDiameterBolt.get(diameterBoltKey(diameter, normalizedBolt)) : null,
          rimOption.offsets,
          lookupMap.offsetsByDiameter.get(diameter),
          normalizedBolt ? lookupMap.offsetsByBolt.get(normalizedBolt) : null,
        ];
        const offsets = offsetSources.find((source) => source?.size);
        return offsets ? sortOffsets([...offsets]) : [];
      };

      const variantItemsForSize = (rimSize, boltPattern = boltSelect.value) => {
        const lookupMap = variantMap.customBuild ? buildLookupOptionMap() : null;
        const sourceSizeOptions = variantMap.customBuild ? lookupMap.sizeOptions : variantMap.sizeOptions;
        const rimOption = sourceSizeOptions.get(normalizeSize(rimSize));
        if (!rimOption) return [];

        if (variantMap.customBuild) {
          const variant = currentProductVariant();
          return customBuildOffsetsForSize(rimOption.rimSize, boltPattern).map((offset) => ({
            variant,
            value: rimOption.rimSize,
            offset,
          }));
        }

        if (variantMap.boltIndex < 0 || !boltPattern) return rimOption.values;

        return rimOption.values.filter((item) => variantOptionValue(item.variant, variantMap.boltIndex) === boltPattern);
      };

      const hasSizeForBolt = (rimSize, boltPattern = boltSelect.value) => variantItemsForSize(rimSize, boltPattern).length > 0;

      const offsetsForSize = (rimSize, boltPattern = boltSelect.value) =>
        [...new Set(variantItemsForSize(rimSize, boltPattern).map((item) => item.offset).filter((offset) => offset !== null))].sort((a, b) => a - b);

      const productSizesForDiameter = (diameter, boltPattern = boltSelect.value) =>
        sortSizes(
          [...(variantMap.customBuild ? buildLookupOptionMap().sizeOptions : variantMap.sizeOptions).values()]
            .filter((item) => !diameter || item.diameter === diameter)
            .filter((item) => hasSizeForBolt(item.rimSize, boltPattern))
            .map((item) => item.rimSize)
        );

      const setupsForCurrentStyle = () => {
        const style = getStyle();
        const diameter = diameterSelect.value;
        return getVehicleSetups().filter((setup) => {
          if (setupStyle(setup) !== style) return false;
          if (!diameter) return true;
          return diameterFromSize(setup[0]) === diameter || diameterFromSize(setup[2]) === diameter;
        });
      };

      const findVariant = (rimSize, offset, boltPattern) => {
        if (variantMap.customBuild) {
          return productVariantForDiameter(diameterFromSize(rimSize) || diameterSelect.value);
        }

        const candidates = variantItemsForSize(rimSize, boltPattern);
        if (candidates.length === 0) return null;

        const exactOffset = candidates.find((item) => Number(item.offset) === Number(offset));
        return (exactOffset || candidates[0])?.variant || null;
      };

      const formatMoney = (price) => {
        const cents = Number(price || 0);
        const amount = cents > 999 ? cents / 100 : cents;
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: root.dataset.moneyCurrency || 'USD',
          }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(2)}`;
        }
      };

      const buildSelection = () => {
        const setup = getMode() === 'manual' ? getManualSetup() : getSelectedSetup();
        const style = getStyle();
        const boltRequired = variantMap.customBuild ? Boolean(getMode() === 'manual' || getSelectedVehicleBoltPattern()) : variantMap.boltPatterns.size > 0;
        const bolt = boltSelect.value;
        const setupConfirmed = root.dataset.setupConfirmed === 'true';
        const completeBase = Boolean(setup && style && diameterSelect.value && (!boltRequired || bolt) && setupConfirmed);

        if (!setup) {
          return {
            complete: false,
            style,
            setup: null,
            bolt,
          };
        }

        const frontVariant = findVariant(setup[0], setup[1], bolt);
        const rearVariant = style === 'square' ? frontVariant : findVariant(setup[2], setup[3], bolt);

        return {
          complete: Boolean(completeBase && frontVariant && rearVariant),
          mode: getMode(),
          style,
          styleLabel: style === 'staggered' ? root.dataset.staggered : root.dataset.square,
          setup,
          bolt,
          diameter: diameterSelect.value,
          vehicle: getMode() === 'manual' ? '' : vehicleLabel(),
          frontVariant,
          rearVariant,
        };
      };

      const updateProperties = () => {
        const selection = buildSelection();
        const setup = selection.setup;
        const frontWheel = setup ? `${setup[0]} ${offsetText(setup[1])}` : '';
        const rearWheel = setup ? `${setup[2]} ${offsetText(setup[3])}` : '';

        properties.mode.value = getMode() === 'manual' ? 'Manual fitment' : 'Vehicle-guided fitment';
        properties.vehicle.value = selection.vehicle || '';
        properties.setup.value = selection.styleLabel || '';
        properties.diameter.value = selection.diameter || diameterSelect.value || '';
        properties.frontWheel.value = frontWheel;
        properties.rearWheel.value = rearWheel;
        properties.offset.value = setup ? formatSetupLabel(setup) : '';
        properties.bolt.value = selection.bolt || boltSelect.value || '';
      };

      const syncSubmitButtonState = () => {
        const selection = buildSelection();
        const variant = selection.frontVariant || selection.rearVariant;
        const idInput = form?.querySelector('[name="id"]');

        if (variant && idInput) {
          idInput.value = variantIdValue(variant.id);
          idInput.disabled = false;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (!nativeSubmitButton) return;

        if (selection.complete) {
          nativeSubmitButton.disabled = false;
          nativeSubmitButton.removeAttribute('disabled');
          nativeSubmitButton.removeAttribute('aria-disabled');
          nativeSubmitButton.classList.remove('disabled');

          if (nativeSubmitButtonText && window.variantStrings?.addToCart) {
            nativeSubmitButtonText.textContent = window.variantStrings.addToCart;
          }

          const soldOutMessage = nativeSubmitButton.querySelector('.sold-out-message');
          soldOutMessage?.classList.add('hidden');
          return;
        }

        nativeSubmitButton.setAttribute('disabled', 'disabled');
      };

      const syncNativeVariant = () => {
        const selection = buildSelection();
        const variant = selection.frontVariant || selection.rearVariant;

        if (variantMap.customBuild && diameterSelect.value) {
          selectValue(getNativeSize(), diameterSelect.value);
        }
        if (!variantMap.customBuild && variant) {
          selectValue(getNativeSize(), variantOptionValue(variant, variantMap.sizeIndex));
        }
        if (!variantMap.customBuild && boltSelect.value) selectValue(getNativeBolt(), boltSelect.value);

        window.setTimeout(hideManagedOptions, 0);
        window.setTimeout(hideManagedOptions, 500);
        updateProperties();
        syncSubmitButtonState();
      };

      const panelMarkup = (label, variant, size, offset, quantity, quantityName) => `
        <section class="ekw-fitment-purchase__line">
          <div class="ekw-fitment-purchase__line-main">
            <div class="ekw-fitment-purchase__line-label">${escapeHtml(label)}</div>
            <div class="ekw-fitment-purchase__details">
              <span class="ekw-fitment-purchase__size">${escapeHtml(size)}</span>
              <span>${escapeHtml(root.dataset.offsetLabel)}: <strong>${escapeHtml(offsetText(offset))}</strong></span>
              ${boltSelect.value ? `<span>${escapeHtml(root.dataset.boltLabel)}: <strong>${escapeHtml(boltSelect.value)}</strong></span>` : ''}
            </div>
            <div class="ekw-fitment-purchase__line-actions">
              <div class="ekw-fitment-purchase__price">
                <strong>${escapeHtml(formatMoney(variant?.price))}</strong>
                <span>${escapeHtml(root.dataset.perWheel)}</span>
              </div>
              <label class="ekw-fitment-purchase__qty">
                <span>${escapeHtml(root.dataset.qtyLabel)}</span>
                <input type="number" min="0" step="1" value="${quantity}" data-fitment-qty="${escapeHtml(quantityName)}">
              </label>
            </div>
          </div>
        </section>
      `;

      const renderResult = () => {
        const selection = buildSelection();

        if (!selection.setup || !selection.complete) {
          result.hidden = true;
          if (resultStep) {
            resultStep.hidden = true;
            resultStep.classList.remove('unlocked');
          }
          result.replaceChildren();
          syncSubmitButtonState();
          if (getMode() === 'vehicle' && !vehicleReady()) {
            setStatus(root.dataset.chooseVehicle);
          } else if (selection.setup && root.dataset.setupConfirmed !== 'true') {
            setStatus(root.dataset.setupConfirmRequired || root.dataset.manualConfirmRequired || root.dataset.completeSelection);
          } else if (getMode() === 'manual') {
            setStatus(root.dataset.completeSelection);
          }
          return;
        }

        const [frontSize, frontOffset, rearSize, rearOffset] = selection.setup;
        if (selection.style === 'square') {
          result.innerHTML = panelMarkup(root.dataset.squareSetup, selection.frontVariant, frontSize, frontOffset, state.squareQty, 'square');
        } else {
          result.innerHTML =
            panelMarkup(root.dataset.front, selection.frontVariant, frontSize, frontOffset, state.frontQty, 'front') +
            panelMarkup(root.dataset.rear, selection.rearVariant, rearSize, rearOffset, state.rearQty, 'rear');
        }

        if (resultStep) {
          resultStep.hidden = false;
          resultStep.classList.add('unlocked');
        }
        result.hidden = false;
        syncSubmitButtonState();
        result.querySelectorAll('[data-fitment-qty]').forEach((input) => {
          input.addEventListener('input', () => {
            const value = normalizeQuantity(input.value);
            if (input.dataset.fitmentQty === 'square') state.squareQty = value;
            if (input.dataset.fitmentQty === 'front') state.frontQty = value;
            if (input.dataset.fitmentQty === 'rear') state.rearQty = value;
          });
          input.addEventListener('change', () => {
            const value = normalizeQuantity(input.value);
            input.value = String(value);
            if (input.dataset.fitmentQty === 'square') state.squareQty = value;
            if (input.dataset.fitmentQty === 'front') state.frontQty = value;
            if (input.dataset.fitmentQty === 'rear') state.rearQty = value;
          });
        });

        setStatus(getMode() === 'manual' ? root.dataset.manualReady : root.dataset.ready);
      };

      const setManualOffsetFieldState = (field, input, visible) => {
        if (!field || !input) return;
        field.hidden = !visible;
        input.disabled = !visible;
        if (!visible) input.value = '';
      };

      const syncManualOffsetFields = () => {
        const manual = getMode() === 'manual';
        const style = getStyle();
        setManualOffsetFieldState(manualSquareOffsetField, manualSquareOffsetInput, manual && style === 'square' && !squareSizeField.hidden);
        setManualOffsetFieldState(manualFrontOffsetField, manualFrontOffsetInput, manual && style === 'staggered' && !frontSizeField.hidden);
        setManualOffsetFieldState(manualRearOffsetField, manualRearOffsetInput, manual && style === 'staggered' && !rearSizeField.hidden);
      };

      const populateOffsets = () => {
        const style = getStyle();
        const mode = getMode();
        let items = [];

        if (mode === 'manual') {
          const setupChanged = setupSelect.value !== '';
          setupField.hidden = true;
          setOptions(setupSelect, [], root.dataset.selectSetup, true, false);
          if (setupChanged) setupSelect.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        if (style === 'square') {
          const size = squareSizeSelect.value;
          if (size) {
            items = setupsForCurrentStyle()
              .filter((setup) => normalizeSize(setup[0]) === normalizeSize(size))
              .map((setup) => ({ label: formatSetupLabel(setup), value: setupKey(setup), setup }));
          }
        } else {
          const frontSize = frontSizeSelect.value;
          const rearSize = rearSizeSelect.value;
          if (frontSize && rearSize) {
            items = setupsForCurrentStyle()
              .filter((setup) => normalizeSize(setup[0]) === normalizeSize(frontSize) && normalizeSize(setup[2]) === normalizeSize(rearSize))
              .map((setup) => ({ label: formatSetupLabel(setup), value: setupKey(setup), setup }));
          }
        }

        setupField.hidden = items.length === 0;
        const preferredSetupKey = mode === 'vehicle' ? state.rememberedSetupKey : '';
        const setupChanged = setOptions(
          setupSelect,
          items,
          root.dataset.selectSetup,
          items.length === 0,
          false,
          preferredSetupKey
        );

        if (setupSelect.value) {
          rememberSelectedSetup();
        } else if (mode === 'vehicle' && vehicleReady() && preferredSetupKey) {
          state.rememberedSetupKey = '';
          state.rememberedSetup = null;
        }

        if (setupChanged) {
          setupSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      const refreshOptions = () => {
        const manual = getMode() === 'manual';
        if (variantMap.customBuild && state.lookup) {
          populateBoltPatternOptions(boltSelect.value);
        }
        const activeBoltPattern = manual ? boltSelect.value : syncVehicleBoltPattern();
        const boltPatterns = availableBoltPatterns();
        vehicleFields.forEach((field) => {
          if (field) field.hidden = manual;
        });
        if (boltField) boltField.hidden = boltPatterns.size === 0 || (!manual && !vehicleReady());
        boltSelect.disabled = !manual || boltPatterns.size === 0;

        const rememberedSetup =
          !manual && vehicleReady() && state.rememberedSetupKey
            ? getVehicleSetups().find((setup) => setupKey(setup) === state.rememberedSetupKey)
            : null;
        if (rememberedSetup) state.rememberedSetup = rememberedSetup;

        const styles = getAvailableStyles();
        setStyleOptions(styles, rememberedSetup ? setupStyle(rememberedSetup) : '');
        const style = getStyle();

        const diameterSet = new Set();
        if (manual) {
          variantMap.diameters.forEach((diameter) => diameterSet.add(diameter));
        } else if (style) {
          getVehicleSetups()
            .filter((setup) => setupStyle(setup) === style)
            .forEach((setup) => {
              diameterSet.add(diameterFromSize(setup[0]));
              diameterSet.add(diameterFromSize(setup[2]));
            });
        }

        const productDiameters = variantMap.customBuild
          ? variantMap.diameters.size > 0
            ? variantMap.diameters
            : buildLookupOptionMap().diameters
          : variantMap.diameters;
        const observedDiameters = sortDiameters([...diameterSet].filter(Boolean));
        const purchasableDiameters = observedDiameters.filter((diameter) => productDiameters.has(diameter));
        const diameterOptions = purchasableDiameters.length ? purchasableDiameters : observedDiameters;

        diameterField.hidden = diameterOptions.length === 0;
        setOptions(
          diameterSelect,
          diameterOptions.map((diameter) => ({ label: diameter, value: diameter })),
          root.dataset.selectDiameter,
          diameterOptions.length === 0,
          false,
          rememberedSetup ? diameterFromSize(rememberedSetup[0]) || diameterFromSize(rememberedSetup[2]) : ''
        );

        const diameter = diameterSelect.value;
        const sizeOptions = productSizesForDiameter(diameter, activeBoltPattern);
        const currentSetups = manual ? [] : setupsForCurrentStyle();

        if (style === 'square') {
          const sizes = manual
            ? sizeOptions
            : sortSizes([...new Set(currentSetups.filter((setup) => setupStyle(setup) === 'square').map((setup) => setup[0]))]).filter((size) =>
                hasSizeForBolt(size, activeBoltPattern)
              );

          squareSizeField.hidden = !diameter || sizes.length === 0;
          frontSizeField.hidden = true;
          rearSizeField.hidden = true;
          setOptions(
            squareSizeSelect,
            sizes.map((size) => ({ label: size, value: size })),
            root.dataset.selectSize,
            sizes.length === 0,
            true,
            rememberedSetup && setupStyle(rememberedSetup) === 'square' ? rememberedSetup[0] : ''
          );
          setOptions(frontSizeSelect, [], root.dataset.selectFrontSize, true);
          setOptions(rearSizeSelect, [], root.dataset.selectRearSize, true);
        } else if (style === 'staggered') {
          const frontSizes = manual
            ? sizeOptions
            : sortSizes([...new Set(currentSetups.map((setup) => setup[0]))]).filter((size) => hasSizeForBolt(size, activeBoltPattern));
          const rearSizes = manual
            ? sizeOptions
            : sortSizes([...new Set(currentSetups.map((setup) => setup[2]))]).filter((size) => hasSizeForBolt(size, activeBoltPattern));

          squareSizeField.hidden = true;
          frontSizeField.hidden = !diameter || frontSizes.length === 0;
          rearSizeField.hidden = !diameter || rearSizes.length === 0;
          setOptions(squareSizeSelect, [], root.dataset.selectSize, true);
          setOptions(
            frontSizeSelect,
            frontSizes.map((size) => ({ label: size, value: size })),
            root.dataset.selectFrontSize,
            frontSizes.length === 0,
            true,
            rememberedSetup && setupStyle(rememberedSetup) === 'staggered' ? rememberedSetup[0] : ''
          );
          setOptions(
            rearSizeSelect,
            rearSizes.map((size) => ({ label: size, value: size })),
            root.dataset.selectRearSize,
            rearSizes.length === 0,
            true,
            rememberedSetup && setupStyle(rememberedSetup) === 'staggered' ? rememberedSetup[2] : ''
          );
        } else {
          squareSizeField.hidden = true;
          frontSizeField.hidden = true;
          rearSizeField.hidden = true;
          setOptions(squareSizeSelect, [], root.dataset.selectSize, true);
          setOptions(frontSizeSelect, [], root.dataset.selectFrontSize, true);
          setOptions(rearSizeSelect, [], root.dataset.selectRearSize, true);
        }

        syncManualOffsetFields();
        populateOffsets();
        if (root.dataset.setupConfirmed === 'true') {
          syncNativeVariant();
        }
        renderResult();

        const currentVehicle = vehicleFromCurrentSelection();
        if (currentVehicle && root.dataset.customerLoggedIn !== 'true' && storeLocalVehicle(currentVehicle)) {
          mergeSavedVehicles();
        }

        if (!state.applyingSavedVehicle) {
          state.activeSavedVehicleKey = currentVehicle && savedVehicleExists(currentVehicle) ? currentVehicle.key : '';
        }
        renderSavedVehicleOptions();
        updateSaveVehiclePrompt();

        if (!manual && vehicleReady() && styles.length === 0) {
          setStatus(root.dataset.noMatch);
        }
      };

      const loadLookup = async () => {
        state.lookup = await fetchJson(root.dataset.fitmentLookupUrl);
        state.lookupOptionMap = null;
        return state.lookup;
      };

      const loadYears = async () => {
        try {
          const lookup = await loadLookup();
          setOptions(yearSelect, (lookup.years || []).map((year) => ({ label: year, value: year })), root.dataset.selectYear, false, false);
          refreshOptions();
        } catch (error) {
          setStatus(root.dataset.apiError);
        }
      };

      const loadManufacturers = async () => {
        const lookup = await loadLookup();
        setOptions(
          manufacturerSelect,
          (lookup.makes?.[yearSelect.value] || []).map((make) => ({ label: make, value: make })),
          root.dataset.selectManufacturer,
          !yearSelect.value,
          false
        );
        setOptions(modelSelect, [], root.dataset.selectModel, true);
        setOptions(trimSelect, [], root.dataset.selectTrim, true);
        state.trimGroups = new Map();
        refreshOptions();
      };

      const loadModels = async () => {
        const lookup = await loadLookup();
        setOptions(
          modelSelect,
          (lookup.models?.[selectionKey(yearSelect.value, manufacturerSelect.value)] || []).map((model) => ({
            label: model,
            value: model,
          })),
          root.dataset.selectModel,
          !manufacturerSelect.value,
          false
        );
        setOptions(trimSelect, [], root.dataset.selectTrim, true);
        state.trimGroups = new Map();
        refreshOptions();
      };

      const loadTrims = async () => {
        const lookup = await loadLookup();
        const trims = (lookup.trims?.[selectionKey(yearSelect.value, manufacturerSelect.value, modelSelect.value)] || []).filter(Boolean);
        const groups = new Map();

        trims.forEach((rawTrim) => {
          const label = displayTrimName(rawTrim);
          if (!groups.has(label)) {
            groups.set(label, {
              label,
              rawTrims: [],
              styles: new Set(),
            });
          }

          const group = groups.get(label);
          group.rawTrims.push(rawTrim);

          const trimStyle = styleFromTrimName(rawTrim);
          if (trimStyle) group.styles.add(trimStyle);

          const vehicle = lookup.vehicles?.[selectionKey(yearSelect.value, manufacturerSelect.value, modelSelect.value, rawTrim)];
          vehicleSetups(vehicle).forEach((setup) => group.styles.add(setupStyle(setup)));
        });

        state.trimGroups = groups;
        setOptions(
          trimSelect,
          [...groups.values()].map((group) => ({ label: group.label, value: group.label })),
          root.dataset.selectTrim,
          groups.size === 0,
          groups.size === 1
        );
        refreshOptions();
      };

      const attachCartSubmit = () => {
        if (!form || form.dataset.ekwFitmentSubmitAttached === 'true') return;
        form.dataset.ekwFitmentSubmitAttached = 'true';

        form.addEventListener(
          'submit',
          async (event) => {
            const selection = buildSelection();

            if (!selection.complete) {
              event.preventDefault();
              event.stopImmediatePropagation();
              setStatus(root.dataset.completeSelection);
              return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            const productForm = form.closest('product-form');
            const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
            const submitButton = productForm?.querySelector('[type="submit"]');
            const spinner = productForm?.querySelector('.loading__spinner');

            if (submitButton?.getAttribute('aria-disabled') === 'true') return;

            if (typeof productForm?.handleErrorMessage === 'function') {
              productForm.handleErrorMessage(false);
            }

            submitButton?.setAttribute('aria-disabled', true);
            submitButton?.classList.add('loading');
            spinner?.classList.remove('hidden');
            setStatus(root.dataset.addingToCart);

            const [frontSize, frontOffset, rearSize, rearOffset] = selection.setup;
            const quantityFor = (name, fallback) => {
              const input = Array.from(result.querySelectorAll('[data-fitment-qty]')).find((field) => field.dataset.fitmentQty === name);
              const value = input ? input.value : fallback;
              const quantity = normalizeQuantity(value);
              if (input) input.value = String(quantity);
              return quantity;
            };
            const squareQuantity = quantityFor('square', state.squareQty);
            const frontQuantity = quantityFor('front', state.frontQty);
            const rearQuantity = quantityFor('rear', state.rearQty);
            const commonProperties = {
              Fitment: selection.mode === 'manual' ? 'Manual specs' : '',
              Vehicle: selection.vehicle,
              Setup: selection.styleLabel,
              'Bolt pattern': selection.bolt,
            };

            const items =
              selection.style === 'square'
                ? [
                    {
                      id: Number(selection.frontVariant.id),
                      quantity: squareQuantity,
                      properties: cleanProperties({
                        ...commonProperties,
                        Wheel: `${frontSize} ${offsetText(frontOffset)}`,
                      }),
                    },
                  ].filter((item) => item.quantity > 0)
                : [
                    {
                      id: Number(selection.frontVariant.id),
                      quantity: frontQuantity,
                      properties: cleanProperties({
                        ...commonProperties,
                        Position: root.dataset.front,
                        Wheel: `${frontSize} ${offsetText(frontOffset)}`,
                      }),
                    },
                    {
                      id: Number(selection.rearVariant.id),
                      quantity: rearQuantity,
                      properties: cleanProperties({
                        ...commonProperties,
                        Position: root.dataset.rear,
                        Wheel: `${rearSize} ${offsetText(rearOffset)}`,
                      }),
                    },
                  ].filter((item) => item.quantity > 0);

            if (items.length === 0) {
              setStatus(root.dataset.quantityRequired || root.dataset.completeSelection);
              if (typeof productForm?.handleErrorMessage === 'function') {
                productForm.handleErrorMessage(root.dataset.quantityRequired || root.dataset.completeSelection);
              }
              submitButton?.classList.remove('loading');
              submitButton?.removeAttribute('aria-disabled');
              spinner?.classList.add('hidden');
              return;
            }

            const payload = { items };
            if (cart?.getSectionsToRender) {
              payload.sections = cart.getSectionsToRender().map((section) => section.id);
              payload.sections_url = window.location.pathname;
              cart.setActiveElement?.(document.activeElement);
            }

            try {
              const response = await fetch(window.routes.cart_add_url, {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(payload),
              });
              const data = await response.json();

              if (!response.ok || data.status) {
                throw new Error(data.description || data.message || root.dataset.cartError);
              }

              if (cart && data.sections) {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: items.map((item) => item.id).join(','),
                    cartData: data,
                  });
                }
                cart.renderContents(data);
              } else {
                window.location = window.routes.cart_url;
                return;
              }

              if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
              setStatus(root.dataset.addedToCart);
            } catch (error) {
              const message = error?.message || root.dataset.cartError;
              if (typeof productForm?.handleErrorMessage === 'function') {
                productForm.handleErrorMessage(message);
              }
              setStatus(message);
            } finally {
              submitButton?.classList.remove('loading');
              submitButton?.removeAttribute('aria-disabled');
              syncSubmitButtonState();
              spinner?.classList.add('hidden');
            }
          },
          { capture: true }
        );
      };

      populateBoltPatternOptions();

      const refreshAfterSetupInputChange = (event) => {
        if (event?.isTrusted) clearRememberedSetup();
        refreshOptions();
      };

      modeInputs.forEach((input) => input.addEventListener('change', refreshAfterSetupInputChange));
      styleInputs.forEach((input) => input.addEventListener('change', refreshAfterSetupInputChange));
      yearSelect.addEventListener('change', loadManufacturers);
      manufacturerSelect.addEventListener('change', loadModels);
      modelSelect.addEventListener('change', loadTrims);
      trimSelect.addEventListener('change', refreshOptions);
      diameterSelect.addEventListener('change', refreshAfterSetupInputChange);
      squareSizeSelect.addEventListener('change', refreshAfterSetupInputChange);
      frontSizeSelect.addEventListener('change', refreshAfterSetupInputChange);
      rearSizeSelect.addEventListener('change', refreshAfterSetupInputChange);
      [manualSquareOffsetInput, manualFrontOffsetInput, manualRearOffsetInput].forEach((input) => {
        input?.addEventListener('input', () => {
          clearRememberedSetup();
          renderResult();
        });
        input?.addEventListener('change', () => {
          clearRememberedSetup();
          renderResult();
        });
      });
      root.addEventListener('ekw:setup-confirmed', () => {
        syncNativeVariant();
        renderResult();
      });
      setupSelect.addEventListener('change', (event) => {
        if (setupSelect.value) {
          rememberSelectedSetup();
        } else if (event.isTrusted || getMode() === 'manual') {
          clearRememberedSetup();
        }
        renderResult();
      });
      boltSelect.addEventListener('change', refreshAfterSetupInputChange);
      if (variantMap.customBuild) {
        productInfo.querySelector('variant-selects')?.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeVariant();
            renderResult();
          }, 0);
        });
      }
      savedVehicleSelect?.addEventListener('change', () => {
        const selectedVehicle = normalizeSavedVehicle(JSON.parse(savedVehicleSelect.selectedOptions[0]?.dataset.vehicle || 'null'));
        if (selectedVehicle) {
          applySavedVehicle(selectedVehicle);
        } else {
          state.activeSavedVehicleKey = '';
          renderSavedVehicleOptions();
          updateSaveVehiclePrompt();
        }
      });
      newVehicleButton?.addEventListener('click', () => {
        state.activeSavedVehicleKey = '';
        state.rememberedSetupKey = '';
        state.rememberedSetup = null;
        if (savedVehicleSelect) savedVehicleSelect.value = '';
        yearSelect.value = '';
        yearSelect.dispatchEvent(new Event('change', { bubbles: true }));
        renderSavedVehicleOptions();
        updateSaveVehiclePrompt();
        yearSelect.focus();
      });
      saveVehicleButton?.addEventListener('click', saveCurrentVehicle);
      dismissSaveVehicleButton?.addEventListener('click', () => {
        const currentVehicle = vehicleFromCurrentSelection();
        if (currentVehicle) state.savePromptDismissedKey = currentVehicle.key;
        updateSaveVehiclePrompt();
      });

      attachCartSubmit();
      refreshSavedVehicles();
      loadYears().then(maybeAutoApplySavedVehicle);
      refreshOptions();
    };

    const initAll = () => {
      document.querySelectorAll('[data-ekw-fitment-purchase]').forEach(initFitmentPurchase);
    };

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fitment-request-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const nhtsaBase = 'https://vpic.nhtsa.dot.gov/api/vehicles';
    const cache = new Map();

    const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
    const keyPart = (value) => cleanText(value).toLowerCase();
    const selectionKey = (...parts) => parts.map(keyPart).join('|');
    const comparable = (value) => keyPart(value).replace(/[^a-z0-9]/g, '');

    const fetchJson = async (url) => {
      if (cache.has(url)) {
        return cache.get(url);
      }

      const response = await fetch(url, {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      const data = await response.json();
      cache.set(url, data);
      return data;
    };

    const toItems = (values, emptyLabel) => {
      return (values || []).map((value) => {
        const text = cleanText(value) || emptyLabel;
        return {
          text,
          value: cleanText(value),
        };
      });
    };

    const setSelectOptions = (select, items, placeholder, disabled = false) => {
      select.replaceChildren();
      select.append(new Option(placeholder, ''));

      items.forEach((item) => {
        select.append(new Option(item.text, item.value));
      });

      select.disabled = disabled;
      select.value = '';
    };

    const setSelectValue = (select, value) => {
      const requestedValue = cleanText(value);
      if (!requestedValue) {
        return '';
      }

      const requestedComparable = comparable(requestedValue);
      const match = Array.from(select.options).find(
        (option) => comparable(option.value) === requestedComparable || comparable(option.textContent) === requestedComparable
      );

      if (match) {
        select.value = match.value;
        return match.value;
      }

      return '';
    };

    const normalizeWheelSize = (diameter, width) => {
      const compactNumber = (value) => {
        const number = Number(value);
        return Number.isFinite(number) ? String(number).replace(/\.0$/, '') : cleanText(value);
      };

      return `${compactNumber(diameter)}x${compactNumber(width)}`;
    };

    const parseProductSpecs = (root) => {
      const script = root.querySelector('[data-fitment-product]');
      const specs = [];
      let product = null;

      try {
        product = script ? JSON.parse(script.textContent) : null;
      } catch (error) {
        product = null;
      }

      const texts = [product?.title];
      (product?.variants || []).forEach((variant) => {
        texts.push(variant?.title, variant?.sku);
        (variant?.options || []).forEach((option) => texts.push(option));
      });

      const specRegex =
        /(\d{2}(?:\.\d+)?)\s*[xX]\s*(\d{1,2}(?:\.\d+)?)(?:\s*(?:ET|et|Offset|offset|OFF|off)\s*([+-]?\d{1,3})|\s+([+-]\d{1,3}))?/g;

      texts.filter(Boolean).forEach((text) => {
        for (const match of String(text).matchAll(specRegex)) {
          specs.push({
            size: normalizeWheelSize(match[1], match[2]),
            offset: match[3] || match[4] ? Number(match[3] || match[4]) : null,
          });
        }
      });

      return specs.filter(
        (spec, index, list) =>
          list.findIndex((item) => item.size === spec.size && item.offset === spec.offset) === index
      );
    };

    const confidenceLabel = (code) => {
      if (code === 'h') return 'high confidence';
      if (code === 'm') return 'medium confidence';
      return 'observed';
    };

    const offsetText = (value) => {
      if (value === null || value === undefined || value === '') return 'offset unknown';
      const number = Number(value);
      if (!Number.isFinite(number)) return `${value} offset`;
      if (number > 0) return `+${number}`;
      return String(number);
    };

    const formatSetup = (setup) => {
      const [frontSize, frontOffset, rearSize, rearOffset, observedCount, confidence] = setup;
      const front = `${frontSize} ${offsetText(frontOffset)}`;
      const rear = `${rearSize} ${offsetText(rearOffset)}`;
      const wheels = front === rear ? `${front} square` : `Front ${front} / Rear ${rear}`;
      const countText = observedCount === 1 ? '1 observed build' : `${observedCount} observed builds`;
      return `${wheels} (${countText}, ${confidenceLabel(confidence)})`;
    };

    const wheelMatchesSpec = (size, offset, spec) => {
      if (cleanText(size).toLowerCase() !== spec.size.toLowerCase()) {
        return false;
      }

      return spec.offset === null || Number(offset) === spec.offset;
    };

    const setupMatchesProduct = (setup, specs) => {
      if (!specs.length) return false;

      const [frontSize, frontOffset, rearSize, rearOffset] = setup;

      if (specs.length > 1) {
        const frontMatch = specs.some((spec) => wheelMatchesSpec(frontSize, frontOffset, spec));
        const rearMatch = specs.some((spec) => wheelMatchesSpec(rearSize, rearOffset, spec));
        if (frontMatch && rearMatch) return true;
      }

      return specs.some(
        (spec) => wheelMatchesSpec(frontSize, frontOffset, spec) || wheelMatchesSpec(rearSize, rearOffset, spec)
      );
    };

    const getVehicleParts = (vehicle) => {
      return [
        vehicle.Trim,
        vehicle.Trim2,
        vehicle.Series,
        vehicle.Series2,
      ].filter(Boolean).join(' / ');
    };

    const initFitmentRequest = (root) => {
      if (root.dataset.initialized === 'true') {
        return;
      }

      root.dataset.initialized = 'true';

      const lookupUrl = root.dataset.fitmentLookupUrl;
      const yearSelect = root.querySelector('[data-fitment-year]');
      const manufacturerSelect = root.querySelector('[data-fitment-manufacturer]');
      const modelSelect = root.querySelector('[data-fitment-model]');
      const configurationSelect = root.querySelector('[data-fitment-configuration]');
      const vinInput = root.querySelector('[data-fitment-vin]');
      const trimInput = root.querySelector('[data-fitment-trim]');
      const decodeButton = root.querySelector('[data-fitment-decode]');
      const status = root.querySelector('[data-fitment-status]');
      const methodInput = root.querySelector('[data-fitment-method]');
      const instantResultInput = root.querySelector('[data-fitment-instant-result]');
      const observedSetupsInput = root.querySelector('[data-fitment-observed-setups]');
      const result = root.querySelector('[data-fitment-result]');
      const resultHeading = root.querySelector('[data-fitment-result-heading]');
      const resultBody = root.querySelector('[data-fitment-result-body]');
      const resultList = root.querySelector('[data-fitment-result-list]');
      const resultNote = root.querySelector('[data-fitment-result-note]');
      const productSpecs = parseProductSpecs(root);

      const setStatus = (message) => {
        if (status) {
          status.textContent = message;
        }
      };

      const markMethod = (method) => {
        if (methodInput) {
          methodInput.value = method;
        }
      };

      const setHiddenResult = (heading, body, setups) => {
        if (instantResultInput) {
          instantResultInput.value = [heading, body].filter(Boolean).join(' - ');
        }

        if (observedSetupsInput) {
          observedSetupsInput.value = setups.join('; ');
        }
      };

      const showResult = ({ heading, body, setups = [], note = root.dataset.fitmentReviewNote }) => {
        if (!result) return;

        result.hidden = false;
        resultHeading.textContent = heading;
        resultBody.textContent = body;
        resultNote.textContent = note;
        resultList.replaceChildren();

        setups.forEach((setup) => {
          const item = document.createElement('li');
          item.textContent = setup;
          resultList.append(item);
        });

        setHiddenResult(heading, body, setups);
      };

      const clearResult = () => {
        if (result) {
          result.hidden = true;
        }

        setHiddenResult('', '', []);
      };

      const getLookup = async () => fetchJson(lookupUrl);

      const findVehicle = (lookup, trimOverride = null) => {
        const year = yearSelect.value;
        const manufacturer = manufacturerSelect.value;
        const model = modelSelect.value;
        const trim = trimOverride === null ? configurationSelect.value || trimInput.value : trimOverride;

        if (!year || !manufacturer || !model) {
          return null;
        }

        const exactKey = selectionKey(year, manufacturer, model, trim);
        if (lookup.vehicles?.[exactKey]) {
          return lookup.vehicles[exactKey];
        }

        if (trim) {
          const trimComparable = comparable(trim);
          const modelKey = selectionKey(year, manufacturer, model);
          const fuzzyTrim = (lookup.trims?.[modelKey] || []).find((value) => {
            const optionComparable = comparable(value);
            return optionComparable && (optionComparable.includes(trimComparable) || trimComparable.includes(optionComparable));
          });

          if (fuzzyTrim) {
            return lookup.vehicles?.[selectionKey(year, manufacturer, model, fuzzyTrim)] || null;
          }
        }

        return null;
      };

      const evaluateFitment = async () => {
        clearResult();

        if (!yearSelect.value || !manufacturerSelect.value || !modelSelect.value) {
          return;
        }

        try {
          const lookup = await getLookup();
          const modelKey = selectionKey(yearSelect.value, manufacturerSelect.value, modelSelect.value);
          const trimOptions = (lookup.trims?.[modelKey] || []).filter(Boolean);

          if (!configurationSelect.value && !trimInput.value && trimOptions.length > 1) {
            showResult({
              heading: root.dataset.fitmentSelectTrim,
              body: root.dataset.fitmentSelectVehicle,
              setups: [],
              note: '',
            });
            return;
          }

          const vehicle = findVehicle(lookup);

          if (!vehicle) {
            showResult({
              heading: root.dataset.fitmentNoMatchHeading,
              body: root.dataset.fitmentNoMatchBody,
              setups: [],
            });
            return;
          }

          const allSetups = vehicle.f || [];
          const matchingSetups = allSetups.filter((setup) => setupMatchesProduct(setup, productSpecs));
          const setupsToShow = (matchingSetups.length ? matchingSetups : allSetups).slice(0, 5).map(formatSetup);

          if (productSpecs.length && matchingSetups.length) {
            showResult({
              heading: root.dataset.fitmentProductMatchHeading,
              body: root.dataset.fitmentProductMatchBody,
              setups: setupsToShow,
            });
          } else if (productSpecs.length && !matchingSetups.length) {
            showResult({
              heading: root.dataset.fitmentProductNoMatchHeading,
              body: root.dataset.fitmentProductNoMatchBody,
              setups: setupsToShow,
            });
          } else {
            showResult({
              heading: root.dataset.fitmentFoundHeading,
              body: root.dataset.fitmentFoundBody,
              setups: setupsToShow,
            });
          }

          markMethod('Instant vehicle fitment lookup');
        } catch (error) {
          setStatus(root.dataset.apiError);
        }
      };

      const loadYears = async () => {
        try {
          const lookup = await getLookup();
          setSelectOptions(yearSelect, toItems(lookup.years || [], root.dataset.baseConfiguration), root.dataset.selectYear);
          markMethod('Instant vehicle fitment lookup');
        } catch (error) {
          const currentYear = new Date().getFullYear() + 1;
          const years = Array.from({ length: currentYear - 1976 }, (_, index) => {
            const year = String(currentYear - index);
            return { text: year, value: year };
          });
          setSelectOptions(yearSelect, years, root.dataset.selectYear);
          setStatus(root.dataset.apiError);
        }
      };

      const loadManufacturers = async () => {
        const year = yearSelect.value;
        setSelectOptions(manufacturerSelect, [], root.dataset.loading, true);
        setSelectOptions(modelSelect, [], root.dataset.selectModel, true);
        setSelectOptions(configurationSelect, [], root.dataset.selectConfiguration, true);
        clearResult();

        if (!year) {
          setSelectOptions(manufacturerSelect, [], root.dataset.selectManufacturer, true);
          return;
        }

        try {
          const lookup = await getLookup();
          const manufacturers = toItems(lookup.makes?.[year] || [], root.dataset.baseConfiguration);
          setSelectOptions(manufacturerSelect, manufacturers, root.dataset.selectManufacturer);
          setStatus('');
        } catch (error) {
          setSelectOptions(manufacturerSelect, [], root.dataset.selectManufacturer, true);
          setStatus(root.dataset.apiError);
        }
      };

      const loadModels = async () => {
        const year = yearSelect.value;
        const manufacturer = manufacturerSelect.value;
        setSelectOptions(modelSelect, [], root.dataset.loading, true);
        setSelectOptions(configurationSelect, [], root.dataset.selectConfiguration, true);
        clearResult();

        if (!year || !manufacturer) {
          setSelectOptions(modelSelect, [], root.dataset.selectModel, true);
          return;
        }

        try {
          const lookup = await getLookup();
          const models = toItems(lookup.models?.[selectionKey(year, manufacturer)] || [], root.dataset.baseConfiguration);
          setSelectOptions(modelSelect, models, root.dataset.selectModel);
          setStatus('');
        } catch (error) {
          setSelectOptions(modelSelect, [], root.dataset.selectModel, true);
          setStatus(root.dataset.apiError);
        }
      };

      const loadConfigurations = async () => {
        const year = yearSelect.value;
        const manufacturer = manufacturerSelect.value;
        const model = modelSelect.value;
        setSelectOptions(configurationSelect, [], root.dataset.loading, true);
        clearResult();

        if (!year || !manufacturer || !model) {
          setSelectOptions(configurationSelect, [], root.dataset.selectConfiguration, true);
          return;
        }

        try {
          const lookup = await getLookup();
          const configurations = toItems(lookup.trims?.[selectionKey(year, manufacturer, model)] || [], root.dataset.baseConfiguration);
          const selectableConfigurations = configurations.filter((item) => item.value);

          if (selectableConfigurations.length > 0) {
            setSelectOptions(configurationSelect, selectableConfigurations, root.dataset.selectConfiguration);
            if (selectableConfigurations.length === 1) {
              configurationSelect.value = selectableConfigurations[0].value;
              trimInput.value = selectableConfigurations[0].value;
            }
          } else {
            setSelectOptions(configurationSelect, [], root.dataset.noConfiguration, true);
          }

          setStatus('');
          await evaluateFitment();
        } catch (error) {
          setSelectOptions(configurationSelect, [], root.dataset.noConfiguration, true);
        }
      };

      const decodeVin = async () => {
        const vin = vinInput.value.trim().toUpperCase();

        if (!vin) {
          setStatus(root.dataset.vinError);
          return;
        }

        decodeButton.disabled = true;
        setStatus(root.dataset.loading);

        try {
          const selectedYear = yearSelect.value;
          const yearQuery = selectedYear ? `&modelyear=${encodeURIComponent(selectedYear)}` : '';
          const url = `${nhtsaBase}/DecodeVinValues/${encodeURIComponent(vin)}?format=json${yearQuery}`;
          const data = await fetchJson(url);
          const vehicle = data?.Results?.[0];

          if (!vehicle) {
            setStatus(root.dataset.vinError);
            return;
          }

          if (vehicle.ModelYear) {
            setSelectValue(yearSelect, vehicle.ModelYear);
            await loadManufacturers();
          }

          if (vehicle.Make) {
            setSelectValue(manufacturerSelect, vehicle.Make);
            await loadModels();
          }

          if (vehicle.Model) {
            setSelectValue(modelSelect, vehicle.Model);
            await loadConfigurations();
          }

          const trim = getVehicleParts(vehicle);

          if (trim) {
            trimInput.value = trim;
            setSelectValue(configurationSelect, trim);
            setStatus(root.dataset.vinSuccess);
          } else {
            setStatus(root.dataset.vinNoTrim);
          }

          markMethod('Instant vehicle fitment lookup with VIN decode');
          await evaluateFitment();
        } catch (error) {
          setStatus(root.dataset.vinError);
        } finally {
          decodeButton.disabled = false;
        }
      };

      yearSelect.addEventListener('change', loadManufacturers);
      manufacturerSelect.addEventListener('change', loadModels);
      modelSelect.addEventListener('change', loadConfigurations);
      configurationSelect.addEventListener('change', () => {
        trimInput.value = configurationSelect.value;
        evaluateFitment();
      });
      trimInput.addEventListener('input', evaluateFitment);
      decodeButton.addEventListener('click', decodeVin);
      vinInput.addEventListener('input', () => {
        vinInput.value = vinInput.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '').slice(0, 17);
      });

      loadYears();
    };

    const initAll = () => {
      document.querySelectorAll('[data-ekw-fitment-request]').forEach(initFitmentRequest);
    };

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
